<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="block relative w-full mt-2">
      <div class="block relative px-4">
        <div class="block relative mb-11">
          <div class="flex items-center justify-center w-full mb-2.5">
            <div>
                <img v-if="profilePic"
                     :src="profilePic"
                  class="block rounded-full ring-2 ring-white w-full h-full"
              style="height: 64px; width: 64px; left: 16px; top: 64px"
                />
               
              <img v-if="!profilePic"
                   src="./../../assets/images/portrait_placeholder.png"
                 class="block rounded-full ring-2 ring-white w-full h-full"
              style="height: 64px; width: 64px; left: 16px; top: 64px"
              />
            </div>
          </div>
          <label
            class="
              flex
              align-center
              justify-center
              text-centerw-full text-sm
              font-bold
              text-darkblack
            "
          >
            {{ firstName }} {{ lastName }}
          </label>
        </div>

        <div class="relative block accordian-list-block mb-9">
          <div class="block relative walter-block bg-white rounded-lg mb-7">
            <div class="card" @click="$router.push({ name: 'ProfileEdit' })">
              <input
                id="tab-single1"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs1"
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  w-full
                "
                for="tab-single1"
              >
                <span class="block relative text-sm font-bold text-darkblack">
                  {{ $t("pages.profile.profile_detail") }}
                </span>
                <span class="flex transform rotate-0 duration-500">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.39143 0.870117C1.30436 0.870138 1.21927 0.896136 1.14706 0.944784C1.07485 0.993432 1.0188 1.06252 0.986072 1.1432C0.953346 1.22389 0.945435 1.3125 0.963353 1.39771C0.981272 1.48291 1.0242 1.56083 1.08666 1.6215L6.46483 6.99967L1.08666 12.3778C1.04467 12.4182 1.01115 12.4664 0.988055 12.5199C0.964962 12.5733 0.952763 12.6308 0.952171 12.689C0.951579 12.7472 0.962607 12.805 0.984609 12.8588C1.00661 12.9127 1.03914 12.9617 1.0803 13.0029C1.12146 13.044 1.17042 13.0765 1.22431 13.0985C1.2782 13.1205 1.33594 13.1316 1.39414 13.131C1.45235 13.1304 1.50985 13.1182 1.56328 13.0951C1.61671 13.072 1.66499 13.0385 1.70531 12.9965L7.39281 7.309C7.47483 7.22695 7.5209 7.11569 7.5209 6.99967C7.5209 6.88366 7.47483 6.7724 7.39281 6.69035L1.70531 1.00285C1.66453 0.960852 1.61574 0.927466 1.56182 0.904667C1.50791 0.881868 1.44996 0.87012 1.39143 0.870117Z"
                      fill="#333333"
                    />
                  </svg>
                </span>
              </label>
            </div>
          </div>

          <div class="block relative walter-block bg-white rounded-lg mb-7">
            <div class="card" @click="$router.push({ name: 'ProfileFAQ' })">
              <input
                id="tab-single2"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs2"
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  w-full
                "
                for="tab-single2"
              >
                <span class="block relative text-sm font-bold text-darkblack">
                  {{ $t("pages.profile.get_help") }}
                </span>
                <span class="flex transform rotate-0 duration-500">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.39143 0.870117C1.30436 0.870138 1.21927 0.896136 1.14706 0.944784C1.07485 0.993432 1.0188 1.06252 0.986072 1.1432C0.953346 1.22389 0.945435 1.3125 0.963353 1.39771C0.981272 1.48291 1.0242 1.56083 1.08666 1.6215L6.46483 6.99967L1.08666 12.3778C1.04467 12.4182 1.01115 12.4664 0.988055 12.5199C0.964962 12.5733 0.952763 12.6308 0.952171 12.689C0.951579 12.7472 0.962607 12.805 0.984609 12.8588C1.00661 12.9127 1.03914 12.9617 1.0803 13.0029C1.12146 13.044 1.17042 13.0765 1.22431 13.0985C1.2782 13.1205 1.33594 13.1316 1.39414 13.131C1.45235 13.1304 1.50985 13.1182 1.56328 13.0951C1.61671 13.072 1.66499 13.0385 1.70531 12.9965L7.39281 7.309C7.47483 7.22695 7.5209 7.11569 7.5209 6.99967C7.5209 6.88366 7.47483 6.7724 7.39281 6.69035L1.70531 1.00285C1.66453 0.960852 1.61574 0.927466 1.56182 0.904667C1.50791 0.881868 1.44996 0.87012 1.39143 0.870117Z"
                      fill="#333333"
                    />
                  </svg>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileLanding",
  data() {
    return {
      firstName: "",
      lastName: "",
       pic: {
        original: null,
        thumb: null,
      },
      getDetails: JSON.parse(localStorage.getItem("profile")),
      profilePic: ""
    };
  },
  mounted() {
    this.firstName = this.user.first_name;
    this.lastName = this.user.last_name;
    this.profilePic = this.getDetails.pic_url_photo;
    
  },
};
</script>

<style>
.tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}

.tab input:checked ~ .tab-content {
  max-height: unset;
}
.tab input:checked + label .rotate-0 {
  -webkit-transform: rotate(90deg) !important;
  transform: rotate(90deg) !important;
}
</style>
